const TZ_BRASILIA = "America/Sao_Paulo";

/**
 * Formata instante no fuso oficial de Brasília (America/Sao_Paulo).
 * @returns {string} yyyy-MM-dd HH:mm:ss
 */
export function agoraBrasilia(date = new Date()) {
    return formatarEmFuso(date, TZ_BRASILIA);
}

export function getTimezoneBrasilia() {
    return TZ_BRASILIA;
}

export function getTimezoneNavegador() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone ?? "desconhecido";
    } catch {
        return "desconhecido";
    }
}

function formatarEmFuso(date, timeZone) {
    const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).formatToParts(date);

    const p = (type) => parts.find((x) => x.type === type)?.value ?? "";

    return `${p("year")}-${p("month")}-${p("day")} ${p("hour")}:${p("minute")}:${p("second")}`;
}
